// Centralized route path constants for navigation
export const ROUTE_PATHS = {
  DASHBOARD: '/dashboard',
  DEPLOYMENTS: '/deployments',
  DEPLOYMENT_DETAIL: (id: string) => `/deployment/${id}`,
  CATALOG: '/catalog',
  MODEL_DETAIL: (id: string) => `/model/${id}`,
  PROMPT_LAB: '/prompt-lab',
  PROMPT_LAB_ADD: '/prompt-lab/add',
  PROMPT_LAB_EDIT: (id: string) => `/prompt-lab/edit/${id}`,
  RAG: '/rag',
  RAG_ADD: '/rag/add',
  FINE_TUNING: '/fine-tuning',
  DATASETS: '/evaluation/datasets',
  DATASETS_ADD: '/evaluation/datasets/add',
  EVALUATION: '/evaluation',
  EVALUATION_ADD: '/evaluation/add',
  EVALUATION_DETAIL: (id: string) => `/evaluation/${id}`,
  // Add more routes as needed
};
